import { action, makeObservable, observable } from "mobx";
import { ICollection } from "../../entities/Collection/CollectionTypes";
import BusyStore from "../../stores/common/BusyStore";

// TODO: nik rename to collection offer context
class BaseModalOperationsStore<ModalType> extends BusyStore {
  isModalVisible: boolean = false;
  currentModal: ModalType;
  didUserRejectsWalletAction: boolean = false;
  didUserApprovedAction = false;

  currentCollection: ICollection | null = null;

  constructor(currentModal: ModalType) {
    super();
    makeObservable(this, {
      isModalVisible: observable,
      didUserRejectsWalletAction: observable,
      didUserApprovedAction: observable,
      currentModal: observable,
      currentCollection: observable,

      setCurrentModal: action,
      setModalVisibility: action,
      setUserRejectsWalletActionStatus: action,
      setCurrentCollection: action,
      resetCurrentCollection: action,
      setUserApprovedActionStatus: action,
    });
    this.currentModal = currentModal;
  }

  setUserApprovedActionStatus(status: boolean) {
    this.didUserApprovedAction = status;
  }

  setCurrentCollection(collection: ICollection) {
    this.currentCollection = collection;
  }

  resetCurrentCollection() {
    this.currentCollection = null;
  }

  setModalVisibility(status: boolean) {
    this.isModalVisible = status;
  }

  setCurrentModal(modalName: ModalType) {
    this.currentModal = modalName;
  }

  setUserRejectsWalletActionStatus(status: boolean) {
    this.didUserRejectsWalletAction = status;
  }
}

export default BaseModalOperationsStore;
